/**
 * FOCUS BOOSTER - Variant Picker
 *
 * Lógica de UI para el selector de variantes multi-paso:
 *   1. Pack switcher     — Preserva la presentación seleccionada al navegar entre
 *                          producto de 30 y 90 días. Para 30 días: actualiza el link
 *                          al 90 días según la presentación elegida (envase vs sachets).
 *   2. Presentación      — Toggle visual.
 *                          · 30 días: radios → update de variante.
 *                          · 90 días nuevos: links de navegación (no requiere lógica JS).
 *   3. Sabor             — Grid de imágenes con feedback visual y update de variante.
 *                          Solo para 30 días y legacy 90 días.
 *   4. Slot picker       — Siempre visible en los productos 90 días nuevos.
 *                          Al completar 3 slots, ordena los sabores de forma canónica
 *                          (por orden de aparición en los tiles), construye el string
 *                          de combo y busca el variant_id correspondiente.
 *                          En el legacy 90 días: aparece solo cuando se elige "Variedad/Mix".
 */

(function () {
  'use strict';

  // ─── Estado global ────────────────────────────────────────────────────────
  var isMobile = window.innerWidth <= 640;
  var variantPicker, form, variants;
  var is90Dias = false;
  var is90DiasNew = false;     // true solo para focus-booster-90-dias-envase / sachets
  var MIX_REQUIRED = 3;
  var slots = [];              // ['Limonada de Coco', null, 'Sandía'] — null = vacío
  var variantDebounceTimer = null;

  // ─── Arranque ─────────────────────────────────────────────────────────────
  function init() {
    variantPicker = document.querySelector('.focus-variant-picker');
    if (!variantPicker) return;

    var formId = variantPicker.getAttribute('form-id');
    form = document.getElementById(formId);
    if (!form) return;

    is90Dias    = variantPicker.hasAttribute('data-is-90');
    is90DiasNew = variantPicker.hasAttribute('data-is-90-new');

    var scriptEl = variantPicker.querySelector('script[data-product-variants]');
    if (scriptEl) {
      try { variants = JSON.parse(scriptEl.textContent); }
      catch (e) { variants = []; }
    }

    initPackSwitcher();
    initScrollPreserve();

    if (is90DiasNew) {
      // Productos nuevos de 90 días: solo inicializar el slot picker
      initSlotPicker();
      updateAtcState();          // ATC deshabilitado hasta completar los 3 slots
    } else {
      // 30 días y legacy 90 días: flujo original
      attachRadioListeners();
      attachToggleListener();
      applyClasses();

      if (is90Dias) {
        initSlotPicker();
        handleFlavorChange();   // estado inicial del slot picker (legacy)
      }

      if (!isMobile) updateFlavorImages();
      if (isMobile) updateFlavorPreview();
    }
    applyClasses();
    updateFlavorAvailability();
  }

  // ─── DISPONIBILIDAD DE SABOR SEGÚN PRESENTACIÓN (BioBoosters) ──────────────
  // El grid de sabores refleja la disponibilidad de la variante real
  // (sabor + presentación seleccionada), no la primera variante del sabor.
  function updateFlavorAvailability() {
    if (!variants || !variants.length) return;
    var options = variantPicker.querySelectorAll('.flavor-option');
    if (!options.length) return;
    var presRadio = variantPicker.querySelector('.presentation-toggle__radio:checked, .presentation-tabs input[type="radio"]:checked');
    var pres = presRadio ? presRadio.value : null;
    var firstAvailable = null, checkedDisabled = false;

    options.forEach(function (opt) {
      var flavor = opt.getAttribute('data-flavor');
      var input = opt.querySelector('input');
      var badge = opt.querySelector('.flavor-option__badge');
      var avail = false;
      if (flavor) {
        var v = variants.filter(function (vv) {
          var o = vv.options || [vv.option1, vv.option2, vv.option3];
          var hasF = o.indexOf(flavor) > -1;
          var hasP = pres ? o.indexOf(pres) > -1 : true;
          return hasF && hasP;
        })[0];
        avail = v ? !!v.available : false;
      }
      opt.classList.toggle('flavor-option--disabled', !avail);
      if (input) input.disabled = !avail;
      if (badge) badge.style.display = avail ? 'none' : '';
      if (avail && !firstAvailable) firstAvailable = input;
      if (input && input.checked && !avail) checkedDisabled = true;
    });

    // Si el sabor seleccionado quedó agotado en esta presentación, mover a la primera disponible.
    if (checkedDisabled && firstAvailable) {
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ─── ANTI-BRINCO al navegar entre productos (BioBoosters custom) ──────────
  // El pack switcher (30↔90) y la presentación (envase↔sachets en 90 días)
  // navegan a OTRO producto. Marcamos un flag para que la página destino
  // aterrice directo en la sección del selector sin brincar primero al top.
  function initScrollPreserve() {
    variantPicker.querySelectorAll('a[href*="focus-variants"]').forEach(function (link) {
      link.addEventListener('click', function () {
        try { sessionStorage.setItem('fvpScroll', '1'); } catch (e) {}
      });
    });
  }

  // ─── PACK SWITCHER ────────────────────────────────────────────────────────
  function initPackSwitcher() {
    if (is90DiasNew) {
      // Productos 90 días nuevos: el pack switcher tiene links estáticos — no necesita JS.
      return;
    }

    if (is90Dias) {
      // Legacy 90 días: restaurar la presentación desde query param (igual que antes).
      var params = new URLSearchParams(window.location.search);
      var presentationParam = params.get('presentation');
      if (presentationParam) {
        var changed = false;
        variantPicker.querySelectorAll('.presentation-toggle__radio, .presentation-tabs input[type="radio"]').forEach(function (radio) {
          if (radio.value.toLowerCase() === presentationParam.toLowerCase()) {
            radio.checked = true;
            changed = true;
          }
        });
        if (changed) {
          applyClasses();
          setTimeout(function () { updateVariant(); }, 50);
        }
      }
      return;
    }

    // ── Producto 30 días ──────────────────────────────────────────────────
    // 1. Restaurar presentación desde query param al volver del 90 días.
    var params30 = new URLSearchParams(window.location.search);
    var presentationParam30 = params30.get('presentation');
    if (presentationParam30) {
      var changed30 = false;
      variantPicker.querySelectorAll('.presentation-toggle__radio').forEach(function (radio) {
        if (radio.value.toLowerCase() === presentationParam30.toLowerCase()) {
          radio.checked = true;
          changed30 = true;
        }
      });
      if (changed30) {
        applyClasses();
        setTimeout(function () { updateVariant(); }, 50);
      }
    }

    // 2. Actualizar el link al 90 días según la presentación seleccionada.
    //    Si Envase → focus-booster-90-dias-envase
    //    Si Sachets → focus-booster-90-dias-sachets
    var pack90Card = variantPicker.querySelector('[data-pack-card-90]');
    if (!pack90Card || pack90Card.tagName.toLowerCase() !== 'a') return;

    function update90Link() {
      var checked = variantPicker.querySelector('.presentation-toggle__radio:checked');
      var isSachets = checked && checked.value.toLowerCase().includes('sachets');
      var handle = isSachets
        ? 'focus-booster-90-dias-sachets'
        : 'focus-booster-90-dias-envase';
      pack90Card.href = '/products/' + handle + '#focus-variants';
    }

    variantPicker.querySelectorAll('.presentation-toggle__radio').forEach(function (radio) {
      radio.addEventListener('change', update90Link);
    });

    update90Link();
  }

  // ─── LISTENERS (30 días y legacy 90 días) ─────────────────────────────────
  function attachRadioListeners() {
    variantPicker.querySelectorAll('input[type="radio"]').forEach(function (radio) {

      radio.addEventListener('change', function () {
        var isPresentationChange = !!this.closest('.presentation-tabs, .presentation-toggle');

        applyClasses();
        if (isPresentationChange) updateFlavorAvailability(); // BioBoosters: 'Agotado' según presentación
        if (isMobile) updateFlavorPreview(); // inmediato, sin debounce

        clearTimeout(variantDebounceTimer);
        variantDebounceTimer = setTimeout(function () {
          updateVariant();
          if (isPresentationChange && !isMobile) updateFlavorImages();
          if (is90Dias) handleFlavorChange();
        }, 120);
      });

      radio.addEventListener('click', function () {
        applyClasses();
      });
    });
  }

  // ─── PREVIEW DE SABOR EN MÓVIL (30 días) ─────────────────────────────────
  function updateFlavorPreview() {
    var previewSlot = variantPicker.querySelector('.flavor-grid__preview-slot');
    if (!previewSlot) return;

    var slotEmpty  = previewSlot.querySelector('.flavor-grid__preview-slot-empty');
    var slotFilled = previewSlot.querySelector('.flavor-grid__preview-slot-filled');
    var slotImg    = previewSlot.querySelector('.flavor-grid__preview-slot-img');
    var slotName   = previewSlot.querySelector('.flavor-grid__preview-slot-name');

    // Sabor seleccionado
    var selectedFlavor = variantPicker.querySelector('.flavor-option input:checked');
    if (!selectedFlavor) {
      if (slotEmpty)  slotEmpty.style.display  = 'flex';
      if (slotFilled) slotFilled.style.display = 'none';
      return;
    }

    // Presentación activa
    var presentationRadio = variantPicker.querySelector('.presentation-toggle__radio:checked');
    var isSachets = presentationRadio && presentationRadio.value.toLowerCase().includes('sachet');
    var presentation = isSachets ? 'sachets' : 'envase';

    // Normalizar nombre del sabor para matchear data-attributes
    var flavorVal = selectedFlavor.value.toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[-_]/g, ' ');

    console.log('[FP preview] value="' + selectedFlavor.value + '" normalized="' + flavorVal + '" presentation=' + presentation);

    var flavorKey;
    // variedad primero — su nombre puede contener "cacao", "sandia", etc.
    if (flavorVal.includes('varie') || flavorVal.includes('mix') || flavorVal.includes('variety') || flavorVal.includes('pack')) flavorKey = 'variedad';
    else if (flavorVal.includes('cacao') || flavorVal.includes('chocolate')) flavorKey = 'cacao';
    else if (flavorVal.includes('sandia')) flavorKey = 'sandia';
    else if (flavorVal.includes('limonada') || flavorVal.includes('coco')) flavorKey = 'limonada';

    console.log('[FP preview] flavorKey=' + flavorKey);

    if (!flavorKey || (flavorKey === 'variedad' && presentation === 'envase')) {
      if (slotEmpty)  slotEmpty.style.display  = 'flex';
      if (slotFilled) slotFilled.style.display = 'none';
      return;
    }

    var key = 'data-' + presentation + '-' + flavorKey;
    var src = previewSlot.getAttribute(key);

    if (src && slotImg) {
      slotImg.src = src;
      if (slotName) slotName.textContent = selectedFlavor.value;
      if (slotEmpty)  slotEmpty.style.display  = 'none';
      if (slotFilled) slotFilled.style.display = 'flex';
    }
  }

  // ─── CLASES CSS (30 días y legacy 90 días) ─────────────────────────────────
  function applyClasses() {
    // Toggle de presentación — pill bicolor
    // Para 90 días nuevos el toggle usa <span>/<a> renderizado por Liquid (estado
    // ya correcto desde el servidor). No sobreescribir con la lógica de radios.
    if (!is90DiasNew) {
      var toggleOptions = variantPicker.querySelectorAll('.presentation-toggle__option');
      if (toggleOptions.length >= 2) {
        var toggleRadios = variantPicker.querySelectorAll('.presentation-toggle__radio');
        var isSecond = toggleRadios.length > 1 && toggleRadios[1].checked;
        toggleOptions[0].classList.toggle('presentation-toggle__option--active', !isSecond);
        toggleOptions[1].classList.toggle('presentation-toggle__option--active', isSecond);
      }
    }

    // Tabs de presentación (legacy)
    variantPicker.querySelectorAll('.presentation-tab').forEach(function (tab) {
      var radio = tab.querySelector('input[type="radio"]');
      tab.classList.toggle('presentation-tab--selected', !!(radio && radio.checked));
    });

    // Flavor grid
    variantPicker.querySelectorAll('.flavor-option').forEach(function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      opt.classList.toggle('flavor-option--selected', !!(radio && radio.checked));
    });

     // ── Ocultar "Variety pack" en Envase, mostrar en Sachets ──
    var variedadOption = variantPicker.querySelector('.flavor-option--variedad');
    if (variedadOption) {
      var radios = variantPicker.querySelectorAll('.presentation-toggle__radio');
      var isSachets = radios.length > 1 && radios[1].checked;
      variedadOption.style.display = isSachets ? '' : 'none';
    }
  }

  // ─── UPDATE VARIANT (30 días y legacy 90 días) ────────────────────────────
  function updateVariant() {
    var option1 = variantPicker.querySelector('input[name$="-option1"]:checked');
    var option2 = variantPicker.querySelector('input[name$="-option2"]:checked');
    if (!option1 || !option2 || !variants) return;

    var variant = variants.find(function (v) {
      return v.option1 === option1.value && v.option2 === option2.value;
    });
    if (!variant) return;

    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value !== variant.id.toString()) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant-change', {
        detail: { variant: variant },
        bubbles: true
      }));
      updateMainProductImage(variant);

      // Validar disponibilidad de inventario y habilitar/deshabilitar ATC
      var isAvailable = isVariantAvailable(variant);
      setAtcEnabled(isAvailable);
      setDynamicCheckoutVisible(isAvailable); // BIOBOOSTERS CUSTOM: ocultar "Comprar ahora" si agotado

      if (is90Dias) {
        setTimeout(function () { handleFlavorChange(); }, 600);
      }
    } else if (idInput) {
      // Aunque no cambie la variante, actualizar la suscripción por restricción de sabor
      var avail = isVariantAvailable(variant);
      setAtcEnabled(avail);
      setDynamicCheckoutVisible(avail); // BIOBOOSTERS CUSTOM
    }
  }

  // ─── FLAVOR CHANGE HANDLER (solo legacy 90 días) ──────────────────────────
  function handleFlavorChange() {
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (!slotPicker) return;

    var checkedFlavor = variantPicker.querySelector('.flavor-grid input[type="radio"]:checked');
    var isVariedad = checkedFlavor && isVariedadValue(checkedFlavor.value);

    if (isVariedad) {
      slotPicker.classList.remove('slot-picker--hidden');
      // Sincronizar el estado disabled de las tiles según su disponibilidad actual
      syncTileDisabledState();
      updateAtcState();
    } else {
      slotPicker.classList.add('slot-picker--hidden');
      setAtcEnabled(true);
      removeLineItemProperties();
      resetSlots();
    }
  }

  function syncTileDisabledState() {
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (!slotPicker) return;

    slotPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      if (tile.classList.contains('slot-picker__tile--unavailable')) {
        tile.disabled = true;
        tile.setAttribute('aria-disabled', 'true');
      } else {
        tile.disabled = false;
        tile.setAttribute('aria-disabled', 'false');
      }
    });
  }

  function isVariedadValue(value) {
    var v = (value || '').toLowerCase();
    return v.includes('variedad') || v.includes('variety') || v.includes('mix');
  }

  // ─── SLOT PICKER ─────────────────────────────────────────────────────────
  function initSlotPicker() {
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (!slotPicker) return;

    MIX_REQUIRED = parseInt(slotPicker.getAttribute('data-required') || '3', 10);

    slots = [];
    for (var s = 0; s < MIX_REQUIRED; s++) slots.push(null);

    // Inicializar el estado disabled de las tiles basándose en la clase --unavailable
    slotPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      if (tile.classList.contains('slot-picker__tile--unavailable')) {
        tile.disabled = true;
        tile.setAttribute('aria-disabled', 'true');
      } else {
        tile.disabled = false;
        tile.setAttribute('aria-disabled', 'false');
      }
    });

    // Click en tile: llena el primer slot vacío
    slotPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.disabled) return;

        var firstEmpty = slots.indexOf(null);
        if (firstEmpty === -1) return; // todos los slots llenos

        var flavor = tile.getAttribute('data-flavor');
        slots[firstEmpty] = flavor;
        updateSlotUI();
      });
    });

    // Click en slot ocupado: lo vacía
    slotPicker.querySelectorAll('.slot-picker__slot').forEach(function (slot) {
      slot.addEventListener('click', function () {
        var index = parseInt(slot.getAttribute('data-slot-index'), 10);
        if (slots[index] === null) return;

        slots[index] = null;
        updateSlotUI();
      });

      slot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          slot.click();
        }
      });
    });
  }

  function resetSlots() {
    slots = [];
    for (var s = 0; s < MIX_REQUIRED; s++) slots.push(null);
    updateSlotUI();
  }

  function getTileForFlavor(slotPicker, flavor) {
    var tiles = slotPicker.querySelectorAll('.slot-picker__tile');
    for (var i = 0; i < tiles.length; i++) {
      if (tiles[i].getAttribute('data-flavor') === flavor) return tiles[i];
    }
    return null;
  }

  function updateSlotUI() {
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (!slotPicker) return;

    var filledCount = 0;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i] !== null) filledCount++;
    }
    var isComplete = (filledCount === MIX_REQUIRED);

    // Actualizar visual de cada slot
    slotPicker.querySelectorAll('.slot-picker__slot').forEach(function (slotEl) {
      var index = parseInt(slotEl.getAttribute('data-slot-index'), 10);
      var flavor = slots[index];

      if (flavor !== null && flavor !== undefined) {
        var tile = getTileForFlavor(slotPicker, flavor);
        var imgHTML = '';
        if (tile) {
          var tileImgEl = tile.querySelector('.slot-picker__tile-img');
          if (tileImgEl) imgHTML = tileImgEl.innerHTML;
        }

        var imgEl  = slotEl.querySelector('.slot-picker__slot-img');
        var nameEl = slotEl.querySelector('.slot-picker__slot-flavor-name');

        slotEl.classList.add('slot-picker__slot--filled');
        slotEl.setAttribute('aria-label', 'Mes ' + (index + 1) + ': ' + flavor + '. Toca para quitar');
        if (imgEl)  imgEl.innerHTML = imgHTML;
        if (nameEl) nameEl.textContent = flavor;
      } else {
        slotEl.classList.remove('slot-picker__slot--filled');
        slotEl.setAttribute('aria-label', 'Mes ' + (index + 1) + ': vacío');
        var imgEl2  = slotEl.querySelector('.slot-picker__slot-img');
        var nameEl2 = slotEl.querySelector('.slot-picker__slot-flavor-name');
        if (imgEl2)  imgEl2.innerHTML = '';
        if (nameEl2) nameEl2.textContent = '';
      }
    });

    // Tiles: deshabilitar todos cuando el pack está completo (excepto los que ya están unavailable)
    slotPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      if (tile.classList.contains('slot-picker__tile--unavailable')) return;
      tile.disabled = isComplete;
      tile.setAttribute('aria-disabled', isComplete ? 'true' : 'false');
      tile.classList.toggle('slot-picker__tile--locked', isComplete);
    });

    // Hint
    var hintEl    = slotPicker.querySelector('.slot-picker__hint');
    var hintCount = slotPicker.querySelector('.slot-picker__hint-count');
    if (hintEl) {
      var remaining = MIX_REQUIRED - filledCount;
      hintEl.style.display = (remaining === 0) ? 'none' : '';
      if (hintCount) hintCount.textContent = remaining;
    }

    // Al completar: seleccionar variante (nuevo) o agregar line item property (legacy)
    if (isComplete) {
      if (is90DiasNew) {
        selectVariantFromSlots();
      } else {
        setSlotLineItemProperties();
        setAtcEnabled(true);
      }
    } else {
      // Pack incompleto: deshabilitar ATC y limpiar propiedades en ambos modos
      removeLineItemProperties();
      setAtcEnabled(false);
    }
  }

  // ─── VALIDACIÓN DE INVENTARIO ────────────────────────────────────────────
  /**
   * Evalúa si una variante está disponible basándose en su configuración de inventario.
   * Reutiliza la lógica de inventory.liquid para consistencia.
   *
   * - Si variant.available es false → no disponible
   * - Si tiene inventory_management:
   *   - Si inventory_policy es 'deny' → agotado si inventory_quantity <= 0
   *   - Si inventory_policy es 'continue' → siempre disponible
   * - Sin inventory_management → confiar en variant.available
   */
  function isVariantAvailable(variant) {
    if (!variant) return false;

    // Si Shopify ya la marcó como no disponible
    if (!variant.available) return false;

    // Si tiene rastreo de inventario
    if (variant.inventory_management) {
      // Si la política es 'deny' (no permite overselling)
      if (variant.inventory_policy === 'deny') {
        // Agotado si cantidad <= 0
        return variant.inventory_quantity > 0;
      }
      // Si permite overselling, confiar en variant.available
      return variant.available;
    }

    // Sin rastreo: confiar en variant.available
    return variant.available;
  }

  // ─── SELECCIÓN DE VARIANTE POR COMBO (solo 90 días nuevos) ────────────────
  /**
   * Toma los 3 sabores de los slots, los ordena según el orden canónico
   * (el mismo en que aparecen los tiles en el DOM = orden de option.values en focus-booster),
   * construye el string "Sabor A, Sabor B, Sabor C" y busca la variante cuyo option1
   * sea exactamente ese string.
   *
   * Si no se encuentra la variante (p.ej. productos aún no configurados en Shopify),
   * hace fallback a line item property y habilita el botón igualmente.
   *
   * El cliente debe crear los variant values en Shopify usando EXACTAMENTE este orden canónico.
   */
  function selectVariantFromSlots() {
    if (!is90DiasNew) return;

    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (!slotPicker) return;

    // 1. Orden canónico: el orden en que aparecen los tiles en el DOM.
    var tileOrder = [];
    slotPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      tileOrder.push(tile.getAttribute('data-flavor'));
    });

    // 2. Ordenar los 3 sabores seleccionados por su índice en tileOrder.
    var selected = slots.filter(function (s) { return s !== null; });
    if (selected.length !== MIX_REQUIRED) return;

    selected.sort(function (a, b) {
      var idxA = tileOrder.indexOf(a);
      var idxB = tileOrder.indexOf(b);
      if (idxA === -1) idxA = 999;
      if (idxB === -1) idxB = 999;
      return idxA - idxB;
    });

    var comboString = selected.join(', ');

    // 3. Buscar la variante por CONJUNTO de sabores, sin importar el orden.
    //    El orden de los tiles (Sandía, Cacao, Limonada) no coincide con el orden
    //    en que están nombradas las variantes (Limonada, Cacao, Sandía); comparar
    //    el string exacto dejaba el combo sin variante y el pedido/Treli se iba a
    //    la variante por defecto (p. ej. Limonada ×3). Se compara ordenado.
    var claveCombo = function (partes) {
      return partes.map(function (x) { return String(x).trim(); }).filter(Boolean).sort().join('|');
    };
    var claveBuscada = claveCombo(selected);
    var matchingVariant = null;
    if (variants && variants.length) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === comboString ||
            claveCombo(String(variants[i].option1 || '').split(',')) === claveBuscada) {
          matchingVariant = variants[i];
          break;
        }
      }
    }
    if (matchingVariant) comboString = matchingVariant.option1;

    // 4a. Variante encontrada: actualizar input[name="id"] y validar disponibilidad.
    if (matchingVariant) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.disabled = false;  // Prestige inicia el input como disabled; habilitarlo
        if (idInput.value !== matchingVariant.id.toString()) {
          idInput.value = matchingVariant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('variant-change', {
            detail: { variant: matchingVariant },
            bubbles: true
          }));
          updateMainProductImage(matchingVariant);
        }
      }
      removeLineItemProperties();
      hideComboError();

      // Usar validación de inventario en lugar de solo variant.available
      var isAvailable = isVariantAvailable(matchingVariant);
      setAtcEnabled(isAvailable);
      if (!isAvailable) {
        showComboUnavailable();
      } else {
        hideComboUnavailable();
      }
      return;
    }

    // 4b. Variante NO encontrada: fallback a line item property + habilitar botón.
    // Esto ocurre cuando los productos 90 días aún no tienen las variantes de combo
    // configuradas en Shopify. El pedido se crea con la primera variante disponible
    // más la propiedad "Sabores" para identificar la combinación.
    console.warn('[FocusVariantPicker] Combo no encontrado en variantes: "' + comboString + '". Verificar que las variantes del producto estén configuradas con los valores de combo.');
    setSlotLineItemPropertiesForCombo(comboString);
    hideComboError();
    hideComboUnavailable();

    // Asegurar que el input[name="id"] esté habilitado para la submit
    var idInputFallback = form.querySelector('input[name="id"]');
    if (idInputFallback) idInputFallback.disabled = false;

    setAtcEnabled(true);
  }

  function setSlotLineItemPropertiesForCombo(comboString) {
    removeLineItemProperties();
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Sabores]';
    input.value = comboString;
    input.setAttribute('data-mix-property', 'true');
    form.appendChild(input);
  }

  function showComboError(combo) {
    var errEl = variantPicker.querySelector('.slot-picker__combo-error');
    if (errEl) {
      errEl.textContent = 'Esta combinación no está disponible: ' + combo;
      errEl.style.display = '';
    }
  }

  function hideComboError() {
    var errEl = variantPicker.querySelector('.slot-picker__combo-error');
    if (errEl) errEl.style.display = 'none';
  }

  function showComboUnavailable() {
    var el = variantPicker.querySelector('.slot-picker__combo-unavailable');
    if (el) {
      el.style.display = '';
      el.classList.add('is-visible');
    }

    // Agregar clase visual al slot picker para mostrar estado deshabilitado
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (slotPicker) {
      slotPicker.classList.add('slot-picker--unavailable');
    }
  }

  function hideComboUnavailable() {
    var el = variantPicker.querySelector('.slot-picker__combo-unavailable');
    if (el) {
      el.style.display = 'none';
      el.classList.remove('is-visible');
    }

    // Remover clase visual
    var slotPicker = variantPicker.querySelector('.slot-picker');
    if (slotPicker) {
      slotPicker.classList.remove('slot-picker--unavailable');
    }
  }

  // ─── ATC state ───────────────────────────────────────────────────────────
  function updateAtcState() {
    if (is90DiasNew) {
      // Para nuevos 90 días: ATC deshabilitado hasta completar los 3 slots.
      var filledCount = 0;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i] !== null) filledCount++;
      }
      setAtcEnabled(filledCount === MIX_REQUIRED);
      return;
    }

    // Legacy: depende de si "Variedad" está seleccionado.
    var checkedFlavor = variantPicker.querySelector('.flavor-grid input[type="radio"]:checked');
    var isVariedad = checkedFlavor && isVariedadValue(checkedFlavor.value);
    if (!isVariedad) return;

    var filledCount2 = 0;
    for (var j = 0; j < slots.length; j++) {
      if (slots[j] !== null) filledCount2++;
    }
    setAtcEnabled(filledCount2 === MIX_REQUIRED);
  }

  // === BIOBOOSTERS CUSTOM: ocultar el botón de pago dinámico ("Comprar ahora")
  // cuando la variante seleccionada está agotada. En Prestige 11.3 el cambio de
  // variante vía el selector custom ya no re-renderiza los botones, así que el
  // estado agotado no se reflejaba; aquí lo forzamos por JS. ===
  function setDynamicCheckoutVisible(visible) {
    if (!form) return;
    form.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      el.style.display = visible ? '' : 'none';
    });
  }

  function setAtcEnabled(enabled) {
    if (!form) return;

    // Recolectar todos los botones submit asociados a este formulario
    var formId = form.id;
    var buttons = [];

    // Botones dentro del form
    form.querySelectorAll('button[type="submit"], [name="add"]').forEach(function (b) {
      if (buttons.indexOf(b) === -1) buttons.push(b);
    });

    // Botones fuera del form referenciados por form="formId"
    if (formId) {
      document.querySelectorAll(
        'button[type="submit"][form="' + formId + '"], [name="add"][form="' + formId + '"]'
      ).forEach(function (b) {
        if (buttons.indexOf(b) === -1) buttons.push(b);
      });
    }

    if (buttons.length === 0) return;

    buttons.forEach(function (btn) {
      btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (enabled) {
        btn.removeAttribute('data-mix-disabled');
      } else {
        btn.setAttribute('data-mix-disabled', 'true');
      }
    });

    // También deshabilitar selectores de suscripción/presentación si no está disponible
    // Y verificar si hay restricciones específicas por sabor/presentación
    var shouldDisableSubscription = !enabled || isRestrictedFlavor();
    disableSubscriptionOptionsIfNeeded(shouldDisableSubscription);
  }

  /**
   * Verifica si la combinación actual es una sabor/presentación restringida para suscripción.
   * Actualmente restringe: Sachets de Sandía
   */
  function isRestrictedFlavor() {
    if (!variantPicker) return false;

    // Obtener la presentación seleccionada
    var presentationRadio = variantPicker.querySelector('.presentation-toggle__radio:checked, .presentation-tabs input[type="radio"]:checked');
    if (!presentationRadio) return false;

    var presentation = presentationRadio.value.toLowerCase();
    var isSachets = presentation.includes('sachet');

    // Si no es Sachets, no hay restricción
    if (!isSachets) return false;

    // Obtener el sabor seleccionado
    var flavorRadio = variantPicker.querySelector('input[name$="-option2"]:checked, input[name$="-option1"]:checked');
    if (!flavorRadio) return false;

    var flavor = flavorRadio.value.toLowerCase();
    var isSandia = flavor.includes('sandia') || flavor.includes('sandía');

    // Deshabilitar suscripción solo para Sachets + Sandía
    return isSachets && isSandia;
  }

  /**
   * Deshabilita los selectores de suscripción y opciones de presentación cuando el combo está agotado.
   * Busca selectores comunes para subscription/delivery type:
   *   - name="selling_plan_id" (Shopify Subscribe & Save, Bold Subscriptions)
   *   - data-sellersmith-selectable (SellerSmith)
   *   - selectors específicos de tema Prestige
   */
  function disableSubscriptionOptionsIfNeeded(shouldDisable) {
    if (!form) return;

    // Selectores comunes de suscripción
    var selectors = [
      'select[name="selling_plan_id"]',
      'select[name*="subscription"]',
      'select[name*="frequency"]',
      'input[name="selling_plan_id"]',
      '[data-sellersmith-selectable]',
      '.product-form__input--subscription select',
      '.product-form__input--frequency select',
      '[data-delivery-selector]'
    ];

    selectors.forEach(function (selector) {
      form.querySelectorAll(selector).forEach(function (el) {
        el.disabled = shouldDisable;
        el.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
      });
    });

    // También deshabilitar radio buttons de suscripción
    form.querySelectorAll('input[type="radio"][name*="subscription"], input[type="radio"][name*="frequency"]').forEach(function (radio) {
      radio.disabled = shouldDisable;
    });

    // Deshabilitar labels asociados si están deshabilitados
    if (shouldDisable) {
      form.querySelectorAll('label').forEach(function (label) {
        var input = label.querySelector('input[type="radio"][name*="subscription"], input[type="radio"][name*="frequency"], select[name*="subscription"], select[name*="frequency"]');
        if (input && input.disabled) {
          label.style.opacity = '0.5';
          label.style.pointerEvents = 'none';
          label.setAttribute('aria-disabled', 'true');
        }
      });
    } else {
      form.querySelectorAll('label').forEach(function (label) {
        label.style.opacity = '';
        label.style.pointerEvents = '';
        label.removeAttribute('aria-disabled');
      });
    }
  }

  // ─── Line item properties (solo legacy 90 días) ────────────────────────────
  function setSlotLineItemProperties() {
    var value = slots.filter(function (s) { return s !== null; }).join(', ');

    removeLineItemProperties();

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Sabores]';
    input.value = value;
    input.setAttribute('data-mix-property', 'true');
    form.appendChild(input);
  }

  function removeLineItemProperties() {
    if (!form) return;
    form.querySelectorAll('[data-mix-property]').forEach(function (el) { el.remove(); });
  }

  // ─── IMAGEN PRINCIPAL ─────────────────────────────────────────────────────
  function updateMainProductImage(variant) {
    if (!variant.featured_media || !variant.featured_media.preview_image) return;
    var mediaId = variant.featured_media.id.toString();
    var newSrc  = variant.featured_media.preview_image.src;

    var mediaItems = document.querySelectorAll('[data-media-id]');
    var found = false;
    mediaItems.forEach(function (item) {
      if (item.getAttribute('data-media-id') === mediaId) {
        item.classList.add('is-selected', 'is-active');
        var link = item.querySelector('a, button');
        if (link) { link.click(); found = true; }
      }
    });

    if (!found) {
      var selectors = [
        '.product-gallery__image img', '.product-gallery img',
        '.product__media img', '.product__image img',
        '[data-product-image] img', '.flickity-slider img',
        '.product-gallery__carousel-item img'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var img = document.querySelector(selectors[i]);
        if (img) { updateImageWithFade(img, newSrc, variant); break; }
      }
    }
    updatePrestigeThumbnails(mediaId);
  }

  function updateImageWithFade(img, newSrc, variant) {
    img.style.transition = 'opacity 0.25s ease';
    img.style.opacity = '0.4';
    setTimeout(function () {
      img.src = newSrc;
      if (img.srcset) img.srcset = '';
      img.alt = (variant.featured_media && variant.featured_media.alt) || variant.title;
      img.style.opacity = '1';
    }, 250);
  }

  function updatePrestigeThumbnails(mediaId) {
    document.querySelectorAll('.product-gallery__thumbnail, [data-media-thumbnail], [data-thumbnail]')
      .forEach(function (thumb) {
        var thumbId = thumb.getAttribute('data-media-id') || thumb.getAttribute('data-thumbnail-id');
        thumb.classList.remove('is-selected', 'is-active', 'active');
        thumb.setAttribute('aria-current', 'false');
        if (thumbId && thumbId === mediaId) {
          thumb.classList.add('is-selected', 'is-active');
          thumb.setAttribute('aria-current', 'true');
          var link = thumb.querySelector('a, button') || thumb;
          if (link && link.click) setTimeout(function () { link.click(); }, 100);
        }
      });
  }

  // ─── IMÁGENES DE FLAVOR por presentación (solo desktop, 30 días / legacy) ─
  function updateImageContainer(container, mediaData) {
    if (!container || !mediaData || !mediaData.preview_image) return;
    var existingImg = container.querySelector('img');
    var size = 200;
    var newSrc = mediaData.preview_image.src.includes('?')
      ? mediaData.preview_image.src + '&width=' + size
      : mediaData.preview_image.src + '?width=' + size;
    if (existingImg) {
      if (existingImg.src === newSrc) return;
      existingImg.src = newSrc;
      if (existingImg.srcset) existingImg.srcset = '';
    } else {
      var img = document.createElement('img');
      img.src = newSrc;
      img.alt = mediaData.alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      container.appendChild(img);
    }
  }

  function getPresentationRadio(onlyChecked) {
    var sel = onlyChecked ? ':checked' : '';
    return variantPicker.querySelector(
      '.presentation-toggle__radio' + sel + ', ' +
      '.presentation-tabs input[type="radio"]' + sel
    );
  }

  function updateFlavorImages() {
    // Solo aplica al 30 días y legacy 90 días; los nuevos 90 días tienen tiles estáticos.
    if (isMobile || !variants || is90DiasNew) return;
    var presentationRadio = getPresentationRadio(true);
    if (!presentationRadio) return;
    var selectedPresentation = presentationRadio.value;

    // Actualizar flavor-option tiles (grid de sabor principal)
    variantPicker.querySelectorAll('.flavor-option').forEach(function (option) {
      if (option.classList.contains('flavor-option--variedad')) return;

      var flavorRadio = option.querySelector('input[type="radio"]');
      if (!flavorRadio) return;

      var matchingVariant = variants.find(function (v) {
        return (v.option1 === flavorRadio.value && v.option2 === selectedPresentation) ||
               (v.option1 === selectedPresentation && v.option2 === flavorRadio.value);
      });
      if (matchingVariant && matchingVariant.featured_media) {
        var imgContainer = option.querySelector('.flavor-option__image');
        if (imgContainer) updateImageContainer(imgContainer, matchingVariant.featured_media);
      }
    });

    // Actualizar slot-picker tiles cuando cambia la presentación (solo legacy)
    variantPicker.querySelectorAll('.slot-picker__tile').forEach(function (tile) {
      var flavor = tile.getAttribute('data-flavor');
      if (!flavor) return;

      var matchingVariant = variants.find(function (v) {
        return (v.option1 === flavor && v.option2 === selectedPresentation) ||
               (v.option1 === selectedPresentation && v.option2 === flavor);
      });
      if (matchingVariant && matchingVariant.featured_media) {
        var imgContainer = tile.querySelector('.slot-picker__tile-img');
        if (imgContainer) updateImageContainer(imgContainer, matchingVariant.featured_media);
      }
    });
  }

  // ─── TOGGLE LISTENER (30 días y legacy 90 días) ────────────────────────────
  function attachToggleListener() {
    var radios = variantPicker.querySelectorAll('.presentation-toggle__radio');
    if (radios.length < 2) return;

    var pill = variantPicker.querySelector('.presentation-toggle__pill');
    if (!pill) return;

    pill.addEventListener('click', function (e) {
      var option = e.target.closest('.presentation-toggle__option');
      if (!option || option.classList.contains('presentation-toggle__option--active')) return;

      var isRight = option.classList.contains('presentation-toggle__option--right');
      var toCheck = isRight ? radios[1] : radios[0];
      toCheck.checked = true;
      toCheck.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // ─── Bootstrap ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();